/*
NOTE:
There's been many deliberations on how to implement interceptors. There's a lot of
question that should be considered:
- should all other requests be halted or aborted while we handling intercepted response?
- should we halt or abort requests before or after handling of interception began?
- after intercepted response is handled should we return it unchanged?
- should we throw something on interception? should it be DOMException "AbortError"?

Root of all these questions is having interception be async and/or stateful.
So if we make interceptor sync, and force it to return Request - the only questions
left are:
1. how to prevent downstream expecter from treating handled statuses as unexpected
2. ...? i think that's it, might add more later.

Answer to Q1: throw abort error and handle it in expecters.
*/
import {HttpClient, HttpClientEnhancer} from '~/library/network-facade';

type InterceptorTool = typeof InterceptorTool;
const InterceptorTool = {
    abort: (): never => {
        throw AbortSignal.abort().reason;
    },
};

export const withStatusInterceptor = (
    status: number,
    onIntercepted: (response: HttpClient.SyncOutput, tools: InterceptorTool) => HttpClient.SyncOutput
): HttpClientEnhancer => {
    return http => async (url, init) => {
        let response = await http(url, init);

        if (response.status === status) {
            response = onIntercepted(response, InterceptorTool) ?? response;
        }
        return response;
    };
};
